import script from "./ItemListVtuber.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemListVtuber.vue?vue&type=script&setup=true&lang=js"

import "./ItemListVtuber.vue?vue&type=style&index=0&id=3e4c0f2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e4c0f2c"]])

export default __exports__